export const facilityManagementMenuDef = [

  {
    "name": "menu.facility_setup",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "facility_m"
    },
    "children": [
      {
        "name": "menu.facility_lead_source_master",
        "resource": "lead_source_master",
        "icon": "fa fa-tag",
        "url": "lead_source_master",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.doctor_block_events",
        "resource": "doctor_block_events",
        "icon": "fa fa-tag",
        "url": "doctor_block_events",
        "auto_crud": true,
        "breadcrumb": "Doctor Master Block Event",
        "check_permission": false,
        "showMenu": true
      },
      {
    name: 'menu.smb_bed_bulk_entry',
    icon: 'fa fa-bed',
    resource: 'smb_bed_bulk_entry',
    url: 'smb_bed_bulk_entry',
    showMenu: true,
    auto_crud: true
  },
      {
        "name": "menu.identity_master",
        "resource": "identity_master",
        "icon": "fa fa-tag",
        "url": "identity_master",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.asa_grading",
        "resource": "asa_grading",
        "icon": "fa fa-tag",
        "url": "asa_grading",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.capping_master",
        "resource": "capping_master",
        "icon": "fa fa-tag",
        "url": "capping_master",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_duty_shift_master",
        "resource": "duty_shift_master",
        "icon": "fa fa-tag",
        "url": "duty_shift_master",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_duty_leave_master",
        "resource": "duty_leave_master",
        "icon": "fa fa-tag",
        "url": "duty_leave_master",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_duty_leave_master",
        "resource": "duty_roaster",
        "icon": "fa fa-tag",
        "url": "duty_roaster",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_duty_leave_master",
        "resource": "duty_roster_format",
        "icon": "fa fa-tag",
        "url": "duty_roster_format",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_duty_leave_master",
        "resource": "duty_roster_nurse_wise",
        "icon": "fa fa-tag",
        "url": "duty_roster_nurse_wise",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.practitioner_doctor_update",
        "resource": "practitioner_doctor_update",
        "icon": "fa fa-tag",
        "url": "practitioner_doctor_update",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.practitioner_doctor_update",
        "resource": "practitioner_user_update",
        "icon": "fa fa-tag",
        "url": "practitioner_user_update",
        "auto_crud": true,
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.practitioner_doctor_update",
        "resource": "user_facility_update",
        "icon": "fa fa-tag",
        "url": "user_facility_update",
        "auto_crud": true,
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.facility_lead_source_type_master",
        "resource": "lead_source_type_master",
        "icon": "fa fa-tag",
        "url": "lead_source_type_master",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.account_config_mapping",
        "resource": "account_config_mapping",
        "icon": "fa fa-tag",
        "url": "account_config_mapping",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_contact_details",
        "resource": "facility_contact_details",
        "icon": "fa fa-tag",
        "url": "facility_contact_details",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_servicetype_revenue",
        "resource": "formula_servicetype_mapping",
        "icon": "fa fa-tag",
        "url": "formula_servicetype_mapping",
        "auto_crud": true,
       
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_contact_details",
        "resource": "patient_contact_details",
        "icon": "fa fa-tag",
        "url": "patient_contact_details",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.formula_master",
        "resource": "formula_master",
        "icon": "fa fa-tag",
        "url": "formula_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        name: 'menu.outside_referral',
        resource: "outside_referal_format_tab",
        icon: 'fa fa-h-square',
        url: 'outside_referal_format_tab',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        "name": "menu.delivery_charges_master",
        "resource": "delivery_charges_master",
        "icon": "fa fa-tag",
        "url": "delivery_charges_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.art_category_master",
        "resource": "art_category_master",
        "icon": "fa fa-tag",
        "url": "art_category_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.registration_validation_master",
        "resource": "registration_validation_master",
        "icon": "fa fa-tag",
        "url": "registration_validation_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.document_master",
        "resource": "document_master",
        "icon": "fa fa-tag",
        "url": "document_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.billing_due_reminder_master",
        "resource": "billing_due_reminder_master",
        "icon": "fa fa-tag",
        "url": "billing_due_reminder_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.care_plan_protocol_master",
        "resource": "care_plan_protocol_master",
        "icon": "fa fa-tag",
        "url": "care_plan_protocol_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.document_type_master",
        "resource": "document_type_master",
        "icon": "fa fa-tag",
        "url": "document_type_master",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_report_template",
        "resource": "facility_report_template",
        "icon": "fa fa-tag",
        "url": "facility_report_template",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_report_identification",
        "resource": "facility_report_identification",
        "icon": "fa fa-tag",
        "url": "facility_report_identification",
        "auto_crud": true,
        "breadcrumb": "Report Identification",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.immunization_master",
        "resource": "immunization_master",
        "icon": "fa fa-user-md",
        "url": "immunization_master",
        "auto_crud": true,
        "breadcrumb": "Immunization master",
        "showMenu": true
      },
      {
        "name": "menu.immunization_master",
        "resource": "immunization_master_mapping",
        "icon": "fa fa-user-md",
        "url": "immunization_master_mapping",
        "auto_crud": true,
        "breadcrumb": "Immunization master mapping",
        "showMenu": true
      },
      {
        "name": "menu.tariff_master",
        "resource": "tariff_master_format",
        "icon": "fa fa-tag",
        "url": "tariff_master_format",
        "auto_crud": true,
        "breadcrumb": "Tariff Master Format"
      },
       {
        "name": "menu.latest_tariff_master",
        "resource": "latest_tariff_master_format",
        "icon": "fa fa-tag",
        "url": "latest_tariff_master_format",
        "auto_crud": true,
        "check_permission": false,
        "showMenu": true,
        "breadcrumb": "Latest Tariff Master Format"
      },
      {
        "name": "menu.tariff_fix_rate_master",
        "resource": "tariff_fix_rate_master",
        "icon": "fa fa-tag",
        "url": "tariff_fix_rate_master",
        "auto_crud": true,
        "breadcrumb": "Tariff Master Format"
      },
      {
        "name": "menu.authority_level_master",
        "resource": "authority_level_master",
        "icon": "fa fa-tag",
        "url": "authority_level_master",
        "auto_crud": true,
        "breadcrumb": "Level Master"
      },
      {
        "name": "menu.authority_workflow_master",
        "resource": "authority_workflow_master",
        "icon": "fa fa-tag",
        "url": "authority_workflow_master",
        "auto_crud": true,
        "breadcrumb": "Authority WorkFlow Master"
      },
      {
        "name": "menu.authority_level_user_mapping",
        "resource": "authority_level_user_mapping",
        "icon": "fa fa-tag",
        "url": "authority_level_user_mapping",
        "auto_crud": true,
        "breadcrumb": "Authority Level User Mapping"
      },
      {
        "name": "menu.workflow_master_setup",
        "resource": "workflow_master_setup",
        "icon": "fa fa-tag",
        "url": "workflow_master_setup",
        "auto_crud": true,
        "breadcrumb": "Work Flow Master"
      },
      {
        "name": "menu.dependent_service_item_mapping",
        "resource": "dependent_service_item_mapping",
        "icon": "fa fa-tag",
        "url": "dependent_service_item_mapping",
        "auto_crud": true,
        "breadcrumb": "Dependent Service Item Mapping"
      },
      {
        "name": 'menu.sponsor_fund_master',
        "resource": 'sponsor_fund_master',
        "url": 'sponsor_fund_master',
        "auto_crud": true,
        "breadcrumb": 'Sponsor Fund Master',
        "showMenu": true
      },
     
      {
        "name": "menu.tariff_new",
        "icon": "fa fa-building-o",
        "resource": "tariff_new",
        "url": "tariff_new",
        "auto_crud": true,
        "breadcrumb": "Tariff New"
      },
      {
        name: 'Tariff Service Item',
        resource: 'tariff_service_item',
        icon: 'fa fa-plus-square',
        url: 'tariff_service_item',
        auto_crud: true,
        breadcrumb: 'Tariff Service Item',
        showMenu: true
      },
      {
        "name": "menu.facility_report_data_collector",
        "resource": "facility_report_data_collector",
        "icon": "fa fa-tag",
        "url": "facility_report_data_collector",
        "auto_crud": true,
        "breadcrumb": "Report Data Collector",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_master_unit_type_master",
        "resource": "facility_master_unit_type_master",
        "icon": "fa fa-tag",
        "url": "facility_master_unit_type_master",
        "auto_crud": true,
        "breadcrumb": "Unit Type Master"
      },
      {
        "name": "menu.unit_master",
        "resource": "unit_master",
        "icon": "fa fa-tag",
        "url": "unit_master",
        "auto_crud": true,
        "breadcrumb": "Unit Master"
      },
      {
        "name": "menu.facility",
        "icon": "fa fa-building-o",
        "resource": "facility",
        "url": "facility",
        "auto_crud": true,
        "breadcrumb": "Facility"
      },
      {
        "name": "menu.facility",
        "icon": "fa fa-building-o",
        "resource": "facility_sysadmin",
        "url": "facility_sysadmin",
        "auto_crud": true,
        "breadcrumb": "facility_sysadmin"
        },
      {
        "name": "menu.update_unit_head",
        "resource": "update_unit_head",
        "icon": "fa fa-tag",
        "url": "update_unit_head",
        "auto_crud": true,
        "breadcrumb": "Unit Master"
      },
      {
        "name": 'menu.facility',
        "resource": 'parent_org',
        "url": 'parent_org',
        "auto_crud": true,
        "breadcrumb": 'Set Parent',
        "showMenu": false
      },
      {
        "name": "menu.question_master",
        "icon": "fa fa-building-o",
        "resource": "question_master",
        "url": "question_master",
        "auto_crud": true,
        "breadcrumb": "question_master"
      },
      {
        "name": "menu.cdss_master",
        "icon": "fa fa-building-o",
        "resource": "cdss_master",
        "url": "cdss_master",
        "auto_crud": true,
        "breadcrumb": "cdss_master"
      },
      {
        name: 'menu.package_schedule_event_off',
        resource: 'package_schedule_event_off',
        icon: 'fa fa-superpowers',
        url: 'package_schedule_event_off',
        auto_crud: true,
        breadcrumb: 'Package Schedule Event Off',
        check_permission: false
      },
      {
        check_permission: false,
        auto_crud: true,
        "url": "multiSelection_doctor",
        "resource": "multiSelection_doctor"
    },
      {
        "name": "menu.wing",
        "icon": "fa fa-building-o",
        "resource": "wing",
        "url": "wing",
        "auto_crud": true,
        "breadcrumb": "Wing"
      },
      {
        "name": "menu.finance_clearnance",
        "resource": "finance_clearnance",
        "icon": "fa fa-tag",
        "url": "finance_clearnance",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.finance_clearnance",
        "resource": "finance_clearnance_cathlab",
        "icon": "fa fa-tag",
        "url": "finance_clearnance_cathlab",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.finance_clearnance",
        "resource": "finance_clearnance_ot",
        "icon": "fa fa-tag",
        "url": "finance_clearnance_ot",
        "auto_crud": true,
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.mac",
        "icon": "fa fa-building-o",
        "resource": "whitelist_mac",
        "url": "whitelist_mac",
        "auto_crud": true,
        "breadcrumb": "Mac Address"
      },
      {
        "name": "menu.floor",
        "icon": "fa fa-building-o",
        "resource": "floor",
        "url": "floor",
        "auto_crud": true,
        "breadcrumb": "Floor"
      },
      {
        "name": "menu.ward",
        "icon": "fa fa-building-o",
        "resource": "ward",
        "url": "ward",
        "auto_crud": true,
        "breadcrumb": "Ward"
      },
      {
        "name": "menu.room",
        "icon": "fa fa-building-o",
        "resource": "room",
        "url": "room",
        "auto_crud": true,
        "breadcrumb": "Room"
      },
      {
        "name": "menu.store",
        "icon": "fa fa-building-o",
        "resource": "store",
        "url": "store",
        "auto_crud": true,
        "breadcrumb": "Store"
      },
      {
        "name": "menu.bed",
        "icon": "fa fa-bed",
        "resource": "bed",
        "url": "bed",
        "auto_crud": true,
        "breadcrumb": "Bed"
      },
      {
        "name": "menu.bed_master_format",
        "icon": "fa fa-bed",
        "resource": "bed_master_format",
        "url": "bed_master_format",
        "auto_crud": true,
        "breadcrumb": "Bed"
      },
      {
        "name": "menu.bed_device_master",
        "icon": "fa fa-bed_device_master",
        "resource": "bed_device_master",
        "url": "bed_device_master",
        "auto_crud": true,
        "breadcrumb": "bed_device_master"
      },
      {
        "name": "menu.department",
        "icon": "fa fa-building-o",
        "resource": "department",
        "url": "department",
        "auto_crud": true,
        "breadcrumb": "Department"
      },
      {
        "name": "menu.cost_centre",
        "icon": "fa fa-building-o",
        "resource": "cost_centre",
        "url": "cost_centre",
        "auto_crud": true,
        "breadcrumb": "Cost Centre"
      },
      {
        "name": "menu.subdepartment",
        "icon": "fa fa-building-o",
        "resource": "subdepartment",
        "url": "subdepartment",
        "auto_crud": true,
        "breadcrumb": "Sub-Department"
      },
      {
        "name": "menu.machine",
        "icon": "fa fa-building-o",
        "resource": "machine",
        "url": "machine",
        "auto_crud": true,
        "breadcrumb": "Machine"
      },
      {
        "name": "menu.centre_location",
        "icon": "fa fa-building-o",
        "resource": "centre_location",
        "url": "centre_location",
        "auto_crud": true,
        "breadcrumb": "Centre Location"
      },
      {
        "name": "menu.machine_scheduling",
        "resource": "schedule_event_machine",
        "icon": "fa fa-superpowers",
        "url": "schedule_event_machine",
        "auto_crud": true,
        "breadcrumb": "Machine Scheduling"
      },
      {
        "name": "menu.diagnostic_machine_schedule",
        "resource": "diagnostic_machine_schedule",
        "icon": "fa fa-superpowers",
        "url": "diagnostic_machine_schedule",
        "auto_crud": true,
        "breadcrumb": "Diagnostic Machine Schedule"
      },
      {
        "name": "Surgery Grade Master",
        "resource": "surgery_grade_master",
        "icon": "fa fa-user-md",
        "url": "surgery_grade_master",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.ot_scheduling",
        "resource": "schedule_event_ot",
        "icon": "fa fa-superpowers",
        "url": "schedule_event_ot",
        "auto_crud": true,
        "breadcrumb": "OT Schedular"
      },
      {
        "name": "menu.tat_master",
        "resource": "tat_master",
        "icon": "fa fa-superpowers",
        "url": "tat_master",
        "auto_crud": true,
        "breadcrumb": "Tat Master"
      },
      {
        "name": 'menu.facility_master_payment_type',
        "resource": 'facility_master_payment_type',
        "url": 'facility_master_payment_type',
        "auto_crud": true,
        "breadcrumb": 'Payment Mode',
        "icon": "fa fa-h-square",
      },
      {
        name: 'menu.manage_location',
        resource: 'userLocation_mapping_care',
        url: 'userLocation_mapping_care',
        showMenu: false,
        auto_crud: true,
        check_permission: false,
        breadcrumb: 'Organization'
      },
      {
        "name": "menu.emr_type_department_mapping_master",
        "resource": "emr_type_department_mapping_master",
        "icon": "fa fa-user-md",
        "url": "emr_type_department_mapping_master",
        "auto_crud": true,
        "breadcrumb": "Emr Type mapping",
        "showMenu": true
      },
      {
        "name": "menu.frequency_language_mapping",
        "resource": "frequency_language_mapping",
        "icon": "fa fa-language",
        "url": "frequency_language_mapping",
        "auto_crud": true,
        "breadcrumb": "Frequency Language Mapping",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.meal_relation_language_mapping",
        "resource": "meal_relation_language_mapping",
        "icon": "fa fa-language",
        "url": "meal_relation_language_mapping",
        "auto_crud": true,
        "breadcrumb": "Meal Relation Language Mapping",
        "check_permission": true,
        "showMenu": true
      },
      {
        name: 'menu.tariff_payer_wise_view',
        resource: "tariff_payer_wise_view",
        icon: 'fa fa-h-square',
        url: 'tariff_payer_wise_view',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.tariff_payer_wise_doctor',
        resource: "tariff_payer_wise_doctor",
        icon: 'fa fa-h-square',
        url: 'tariff_payer_wise_doctor',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.working_hours',
        resource: "working_hours",
        icon: 'fa fa-h-square',
        url: 'working_hours',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      }
     
    ]
  },
  {
    "name": "menu.facility_master",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "refer_m"
    },
    "children": [
      {
        "name": "menu.referral_type_master",
        "resource": "refer_type_master",
        "icon": "fa fa-superpowers",
        "url": "refer_type_master",
        "auto_crud": true,
        "breadcrumb": "Referral Type Master"
      },
      {
        name: 'menu.facility_master_onbording_format',
        resource: 'facility_master_onbording_format',
        icon: 'fa fa-superpowers',
        url: 'facility_master_onbording_format',
        auto_crud: true,
        breadcrumb: 'Facility Master Digital On Boarding',
        showMenu: false
      },
      {
        "name": "menu.referral",
        "resource": "refer",
        "icon": "fa fa-superpowers",
        "url": "refer",
        "auto_crud": true,
        "breadcrumb": "Referral"
      },
      {
        "name": "menu.designation",
        "resource": "facility_master_designation_master",
        "icon": "fa fa-superpowers",
        "url": "facility_master_designation_master",
        "auto_crud": true,
        "breadcrumb": "Designation"
      },
      {
        "name": "menu.onboarding_officer",
        "resource": "facility_user_smb",
        "icon": "fa fa-superpowers",
        "url": "facility_user_smb",
        "auto_crud": true,
        "breadcrumb": "Onboarding Officer"
      },
      {
        "name": "menu.room_rent_calculation_master",
        "resource": "room_rent_calculation",
        "icon": "fa fa-tag",
        "url": "room_rent_calculation",
        "auto_crud": true,
        "breadcrumb": "Room Rent Calculation Master"
      },
      {
        "name": "menu.service_type",
        "resource": "facility_master_service_type",
        "icon": "fa fa-tag",
        "url": "facility_master_service_type",
        "auto_crud": true,
        "breadcrumb": "Service Type"
      },
      {
        "name": "menu.service_type_misc",
        "resource": "facility_master_service_type_misc",
        "icon": "fa fa-tag",
        "url": "facility_master_service_type_misc",
        "auto_crud": true,
        "breadcrumb": "Service Type Miscellaneous"
      },
      {
        "name": "menu.service_priority",
        "resource": "facility_master_service_priority",
        "icon": "fa fa-tag",
        "url": "facility_master_service_priority",
        "auto_crud": true,
        "breadcrumb": "Service Priority"
      },
      {
        "name": "menu.billing_category",
        "resource": "facility_master_billing_category",
        "icon": "fa fa-tag",
        "url": "facility_master_billing_category",
        "auto_crud": true,
        "breadcrumb": "Billing Category"
      },
      {
        "name": "menu.tariff_master",
        "resource": "facility_master_tariff_master",
        "icon": "fa fa-tag",
        "url": "facility_master_tariff_master",
        "auto_crud": true,
        "breadcrumb": "Tariff Master"
      },
      {
        "name": "menu.tariff_master",
        "resource": "update_facility_master_tariff_master",
        "icon": "fa fa-plus-square",
        "url": "update_facility_master_tariff_master",
        "check_permission": false,
        "auto_crud": true,
        "showMenu": true
      },
      {
        "name": "menu.tariff_facility_mapping",
        "resource": "tariff_facility_mapping",
        "icon": "fa fa-tag",
        "url": "tariff_facility_mapping",
        "auto_crud": true,
        "breadcrumb": "Tariff-Facility Mapping"
      },
      {
        "name": "menu.speciality_master",
        "resource": "facility_master_speciality_master",
        "icon": "fa fa-tag",
        "url": "facility_master_speciality_master",
        "auto_crud": true,
        "breadcrumb": "Speciality Master"
      },
      {
        "name": "menu.package_type",
        "resource": "facility_master_package_type",
        "icon": "fa fa-tag",
        "url": "facility_master_package_type",
        "auto_crud": true,
        "breadcrumb": "Package Type"
      },
      {
        "name": "menu.surgery_category",
        "resource": "facility_master_surgery_category",
        "icon": "fa fa-tag",
        "url": "facility_master_surgery_category",
        "auto_crud": true,
        "breadcrumb": "Surgery Category"
      },
      {
        "name": "menu.special_tariff_rate",
        "resource": "special_tariff_rate",
        "icon": "fa fa-tag",
        "url": "special_tariff_rate",
        "auto_crud": true,
        "breadcrumb": "Surgery Category"
      },
       {
        "name": "menu.special_tariff_rate",
        "resource": "special_tariff_rate",
        "icon": "fa fa-tag",
        "url": "latest_special_tariff_rate",
        "auto_crud": true,
        "breadcrumb": "Special Tariff Rate"
      },
      {
        "name": "menu.tariff_service_type",
        "resource": "tariff_service_type",
        "icon": "fa fa-tag",
        "url": "tariff_service_type",
        "auto_crud": true,
        "breadcrumb": "Surgery Category"
      },
       {
        "name": "menu.tariff_service_type",
        "resource": "tariff_service_type",
        "icon": "fa fa-tag",
        "url": "latest_tariff_service_type",
        "auto_crud": true,
        "breadcrumb": "Tariff Service Type"
      },
       {
        "name": "menu.tariff_dependency_combination",
        "resource": "tariff_dependency_combination",
        "icon": "fa fa-tag",
        "url": "tariff_dependency_combination",
        "auto_crud": true,
        "breadcrumb": "Tariff Dependency Combination"
      },
      {
        "name": "menu.tariff_timeline_job",
        "icon": "fa fa-tag",
        "resource": "tariff_timeline_job",
        "url": "tariff_timeline_job",
        "auto_crud": true,
        "breadcrumb": "Tariff Timeline"
      },
      {
        "name": "menu.facility_master_cash_denomination",
        "resource": "facility_master_cash_denomination",
        "icon": "fa fa-tag",
        "url": "facility_master_cash_denomination",
        "auto_crud": true,
        "breadcrumb": "Tariff Denomination Master"
      },
      {
        "name": "menu.payer_service_type",
        "resource": "payer_service_type",
        "icon": "fa fa-tag",
        "url": "payer_service_type",
        "auto_crud": true,
        "breadcrumb": "Surgery Category"
      },
       {
        "name": "menu.payer_service_type",
        "resource": "payer_service_type",
        "icon": "fa fa-tag",
        "url": "latest_payer_service_type",
        "auto_crud": true,
        "breadcrumb": "Payer Service Type"
      },
      {
        "name": "menu.payer_dependency",
        "resource": "payer_dependency",
        "icon": "fa fa-tag",
        "url": "payer_dependency",
        "auto_crud": true,
        "breadcrumb": "Surgery Category"
      },
      {
        "name": "menu.surgery_code",
        "resource": "facility_master_surgery_code",
        "icon": "fa fa-tag",
        "url": "facility_master_surgery_code",
        "auto_crud": true,
        "breadcrumb": "Surgery Code"
      },
      {
        "name": "menu.facility_master_doctor_code",
        "resource": "facility_master_doctor_code",
        "icon": "fa fa-tag",
        "url": "facility_master_doctor_code",
        "auto_crud": true,
        "breadcrumb": "Doctor Code"
      },
      {
        "name": "menu.config_mapping",
        "resource": "facility_config_mapping",
        "icon": "fa fa-fa fa-superpowers",
        "url": "facility_config_mapping",
        "auto_crud": true,
        "breadcrumb": "Config Mapping"
      },
      {
        "name": "menu.service_type_stage_action",
        "resource": "service_type_stage_action",
        "icon": "fa fa-tag",
        "url": "service_type_stage_action",
        "auto_crud": true,
        "breadcrumb": "Service Type Stage Action",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.surgery_billing_component",
        "resource": "facility_master_surgery_billing_component",
        "icon": "fa fa-fa fa-superpowers",
        "url": "facility_master_surgery_billing_component",
        "auto_crud": true,
        "breadcrumb": "Surgery Billing Component"
      },
      {
        "name": "menu.billing_category__ward_bed_category__mapping",
        "resource": "billingcategory_ward_mapping",
        "icon": "fa fa-tag",
        "url": "billingcategory_ward_mapping",
        "auto_crud": true,
        "breadcrumb": "Billing/Ward Mapping"
      },
      {
        "name": "menu.diet_billing_category_mapping",
        "resource": "diet_billing_category_mapping",
        "icon": "fa fa-tag",
        "url": "diet_billing_category_mapping",
        "auto_crud": true,
        "breadcrumb": "Billing/Diet Mapping"
      },
      {
        "name": "menu.attender_diet_billing_category_mapping",
        "resource": "attender_diet_billing_category_mapping",
        "icon": "fa fa-tag",
        "url": "attender_diet_billing_category_mapping",
        "auto_crud": true
      },
      {
        "name": "menu.billing_category_diet_mapping_format",
        "resource": "billing_category_diet_mapping_format",
        "icon": "fa fa-tag",
        "url": "billing_category_diet_mapping_format",
        "auto_crud": true
      },
      {
        "name": "menu.pre_op_checklist",
        "resource": "pre_op_checklist",
        "icon": "fa fa-tag",
        "url": "pre_op_checklist",
        "auto_crud": true,
        "breadcrumb": "Pre OP Checklist"
      },
      {
        "name": "menu.post_op_checklist",
        "resource": "post_op_checklist",
        "icon": "fa fa-tag",
        "url": "post_op_checklist",
        "auto_crud": true,
        "breadcrumb": "Post OP Checklist"
      },
      {
        "name": "menu.order_action_definition",
        "resource": "order_action_definition",
        "icon": "fa fa-tag",
        "url": "order_action_definition",
        "auto_crud": true,
        "breadcrumb": "Order Definition"
      },
      {
        "name": "menu.service_type_tax_master",
        "resource": "service_type_tax_master",
        "icon": "fa fa-tag",
        "url": "service_type_tax_master",
        "auto_crud": true,
        "breadcrumb": "Service Type Tax Master"
      },
      {
        "name": "menu.wash_master",
        "resource": "wash_master",
        "icon": "fa fa-tag",
        "url": "wash_master",
        "auto_crud": true,
        "breadcrumb": "Wash Master"
      },
      {
        "name": "menu.wash_master",
        "resource": "practice_type_opd_mapping",
        "icon": "fa fa-tag",
        "url": "practice_type_opd_mapping",
        "auto_crud": true,
        "breadcrumb": "Practice Type OPD Mapping"
      },
      {
        "name": "menu.facility_master_default_body_part",
        "resource": "facility_master_default_body_part",
        "icon": "fa fa-tag",
        "url": "facility_master_default_body_part",
        "auto_crud": true,
        "breadcrumb": "Default Body Part"
      },
      {
        "name": "menu.mis_payout_config",
        "resource": "mis_payout_config",
        "icon": "fa fa-tag",
        "url": "mis_payout_config",
        "auto_crud": true,
        "breadcrumb": "Mis Payout Config"
      },
      {
        "name": "menu.facility_master_payout_type",
        "resource": "facility_master_payout_type",
        "icon": "fa fa-tag",
        "url": "facility_master_payout_type",
        "auto_crud": true,
        "breadcrumb": "Payout Type Master"
      },
      {
        "name": "menu.payout_cycle_master",
        "resource": "payout_cycle_master",
        "icon": "fa fa-tag",
        "url": "payout_cycle_master",
        "auto_crud": true,
        "breadcrumb": "Payout Cycle Master"
      },
      {
        "name": "menu.payout_referral_config",
        "resource": "payout_referral_config",
        "icon": "fa fa-tag",
        "url": "payout_referral_config",
        "auto_crud": true,
        "breadcrumb": "Referral Payout Configuration"
      },
      {
        "name": "menu.payout_mg_level",
        "resource": "payout_mg_level",
        "icon": "fa fa-tag",
        "url": "payout_mg_level",
        "auto_crud": true,
        "breadcrumb": "Payout MG Level"
      },
      {
        "name": "m.outside_referral",
        "resource": "outside_refer",
        "icon": "fa fa-user-md",
        "url": "outside_refer",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Out Side Referral Request"
      },
      {
        "name": "m.outside_referral",
        "resource": "outside_refer",
        "icon": "fa fa-user-md",
        "url": "outside_completed_referred",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Out Side Referral Request"
      },
      {
        "name": "m.outside_referral",
        "resource": "outside_refer",
        "icon": "fa fa-user-md",
        "url": "provider_outside_referred",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Out Side Referral Request"
      },
      {
        "name": "menu.facility_master_payout_deduction",
        "resource": "facility_master_payout_deduction",
        "icon": "fa fa-tag",
        "url": "facility_master_payout_deduction",
        "auto_crud": true,
        "breadcrumb": "Payout Deduction Master"
      },
      {
        "name": "menu.approval_level_creation",
        "resource": "approval_level_creation",
        "icon": "fa fa-tag",
        "url": "approval_level_creation",
        "auto_crud": true,
        "breadcrumb": "Approval Level Creation"
      },
      {
        "name": "menu.service_level_payout",
        "resource": "service_level_payout",
        "icon": "fa fa-tag",
        "url": "service_level_payout",
        "auto_crud": true,
        "breadcrumb": "Service Level Payout"
      },
      {
        "name": "menu.doctor_payout_config",
        "resource": "doctor_payout_config",
        "icon": "fa fa-tag",
        "url": "doctor_payout_config",
        "auto_crud": true,
        "breadcrumb": "Doctor Payout Configuration"
      },
       {
        "name": "menu.sac_code_master",
        "resource": "sac_code_master",
        "icon": "fa fa-tag",
        "url": "sac_code_master",
        "auto_crud": true,
        "breadcrumb": "SAC Code Master",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.doctor_payout_rule_config",
        "resource": "doctor_payout_rule_config",
        "icon": "fa fa-tag",
        "url": "doctor_payout_rule_config",
        "auto_crud": true,
        "breadcrumb": "Doctor Payout Rule Configuration"
      },
      {
        "name": "menu.doctor_payout_unit_master",
        "resource": "doctor_payout_unit_master",
        "icon": "fa fa-tag",
        "url": "doctor_payout_unit_master",
        "auto_crud": true,
        "breadcrumb": "Doctor Payout Unit Master"
      },
      {
        "name": "menu.facility_master_payment_mode_mapping",
        "resource": "facility_master_payment_mode_mapping",
        "icon": "fa fa-tag",
        "url": "facility_master_payment_mode_mapping",
        "auto_crud": true,
        "breadcrumb": "Payment Mode",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.service_type_billing_category_mapping",
        "resource": "service_type_billing_category_mapping",
        "icon": "fa fa-tag",
        "url": "service_type_billing_category_mapping",
        "auto_crud": true,
        "breadcrumb": "mapping master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.centre_type",
        "icon": "fa fa-building-o",
        "resource": "centre_type",
        "url": "centre_type",
        "auto_crud": true,
        "breadcrumb": "Centre Type"
      },
      {
        "name": "menu.common_master",
        "resource": "common_master",
        "icon": "fa fa-tag",
        "url": "common_master",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "common_master"
      },
      {
        "name": "menu.update_patient_insured_amount",
        "resource": "update_patient_insured_amount",
        "icon": "fa fa-tag",
        "url": "update_patient_insured_amount",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "update_patient_insured_amount"
      }
    ]
  },
  {
    "name": "menu.third_party_setup",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "supplier_m"
    },
    "children": [
      {
        "name": "menu.supplier",
        "icon": "fa fa-chain",
        "resource": "supplier",
        "url": "supplier",
        "auto_crud": true,
        "breadcrumb": "Supplier"
      },
      {
        "name": "menu.corporate",
        "icon": "fa fa-chain",
        "resource": "corporate",
        "url": "corporate",
        "auto_crud": true,
        "breadcrumb": "Corporate"
      },
      {
        "name": "menu.manufacturer",
        "icon": "fa fa-industry",
        "resource": "manufacturer",
        "url": "manufacturer",
        "auto_crud": true,
        "breadcrumb": "Manufacturer"
      },
      {
        "name": "menu.outsource_center",
        "icon": "fa fa-industry",
        "resource": "outsource",
        "url": "outsource",
        "auto_crud": true,
        "breadcrumb": "Outsource Centre"
      },
      {
        "name": "menu.outsource_center",
        "icon": "fa fa-industry",
        "resource": "update_outsource",
        "url": "update_outsource",
        "auto_crud": true,
        "breadcrumb": "Outsource Centre"
      },
      {
        "name": "menu.grade_master_mapping",
        "icon": "fa fa-industry",
        "resource": "grade_master_mapping",
        "url": "grade_master_mapping",
        "auto_crud": true,
        "breadcrumb": "Outsource Centre"
      },
      {
        "name": "menu.service_type_payer_mapping",
        "icon": "fa fa-industry",
        "resource": "service_type_payer_mapping",
        "url": "service_type_payer_mapping",
        "auto_crud": true,
        "breadcrumb": "Outsource Centre"
      },
      {
        "name": "menu.referral_request_bypass",
        "icon": "fa fa-industry",
        "resource": "referral_request_bypass",
        "url": "referral_request_bypass",
        "auto_crud": true,
        "breadcrumb": "Outsource Centre"
      },
      {
        "name": "menu.refer_master",
        "icon": "fa fa-industry",
        "resource": "refer_master",
        "url": "refer_master",
        "auto_crud": true,
        "breadcrumb": "Outsource Centre"
      }
    ]
  },
  {
    "name": "menu.service_master",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "catalog_entry_m"
    },
    "children": [
      {
        "name": "menu.service_item",
        "icon": "fa fa-building-o",
        "resource": "catalog_entry",
        "url": "catalog_entry",
        "auto_crud": true,
        "breadcrumb": "Service Item"
      },
      {
        "name": "menu.package_definition",
        "icon": "fa fa-building-o",
        "resource": "package_detail",
        "url": "package_detail",
        "auto_crud": true,
        "breadcrumb": "Package Definition"
      },
      {
        "name": "menu.phc_corporate_mapping",
        "icon": "fa fa-building-o",
        "resource": "phc_corporate_mapping",
        "url": "phc_corporate_mapping",
        "auto_crud": true,
        "breadcrumb": "Package Corporate Definition"
      },
      {
        "name": "menu.package_higher_consumable_item",
        "icon": "fa fa-building-o",
        "resource": "package_higher_consumable_item",
        "url": "package_higher_consumable_item",
        "auto_crud": true,
        "breadcrumb": "Package High Value Consumable Configuration"
      },
      {
        "name": "menu.package_higher_consumable_item_update",
        "icon": "fa fa-building-o",
        "resource": "package_higher_consumable_item_update",
        "url": "package_higher_consumable_item_update",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.phc_definition",
        "icon": "fa fa-building-o",
        "resource": "phc_detail",
        "url": "phc_detail",
        "auto_crud": true,
        "route_def": {
          "dynamic": "/:foreign_id",
          "data": {
            "foreign_id": "package_sub_type_code",
            "add_foreign": true
          }
        },
        "breadcrumb": "PHC Definition"
      },

      {
        "name": "menu.health_assessment_phc_detail",
        "icon": "fa fa-building-o",
        "resource": "health_assessment_phc_detail",
        "url": "health_assessment_phc_detail",
        "auto_crud": true,
        "route_def": {
          "dynamic": "/:foreign_id",
          "data": {
            "foreign_id": "package_sub_type_code",
            "add_foreign": true
          }
        },
        "breadcrumb": "PHC Definition"
      },
      {
        "name": "menu.phc_definition",
        "icon": "fa fa-building-o",
        "resource": "vaccination_detail",
        "url": "vaccination_detail",
        "auto_crud": true,
        "breadcrumb": "PHC Definition"
      },
      {
        "name": "menu.equipment_definition",
        "icon": "fa fa-building-o",
        "resource": "equipment_detail",
        "url": "equipment_detail",
        "auto_crud": true,
        "breadcrumb": "Equipment Definition"
      },
      {
        "name": "menu.adminstrative_service_definition",
        "icon": "fa fa-building-o",
        "resource": "administrative_detail",
        "url": "administrative_detail",
        "auto_crud": true,
        "breadcrumb": "Adminstrative Service Definition"
      },
      {
        "name": "menu.auto_charge_service",
        "icon": "fa fa-building-o",
        "resource": "auto_charge_service",
        "url": "auto_charge_service",
        "auto_crud": true,
        "breadcrumb": "Auto Charge Service"
      },
      {
        "name": "menu.procedure_definition",
        "icon": "fa fa-building-o",
        "resource": "procedure_detail",
        "url": "procedure_detail",
        "auto_crud": true,
        "breadcrumb": "Procedure Definition"
      },
      {
        "name": "menu.physiotherapy_definition",
        "icon": "fa fa-building-o",
        "resource": "physiotherapy_detail",
        "url": "physiotherapy_detail",
        "auto_crud": true,
        "breadcrumb": "Physiotherapy Definition"
      },
      {
        "name": "menu.scheme_master",
        "resource": "scheme_master",
        "icon": "fa fa-tag",
        "url": "scheme_master",
        "auto_crud": true,
        "breadcrumb": "Scheme Master",
        "showMenu": false
      },
      {
        "name": "menu.surgery_detail",
        "icon": "fa fa-building-o",
        "resource": "surgery_detail",
        "url": "surgery_detail",
        "auto_crud": true,
        "breadcrumb": "Surgery Detail"
      },
      {
        "name": "menu.surgery_rule",
        "icon": "fa fa-building-o",
        "resource": "surgery_rule",
        "url": "surgery_rule",
        "auto_crud": true,
        "breadcrumb": "surgery_rule"
      },
      {
        "name": "menu.surgery_billing_component_setup",
        "icon": "fa fa-building-o",
        "resource": "surgery_billing_component_setup",
        "url": "surgery_billing_component_setup",
        "auto_crud": true,
        "breadcrumb": "Surgery Billing Component Setup"
      },
      {
        "name": "menu.anaesthesia_master",
        "resource": "facility_master_anaesthesia_master",
        "icon": "fa fa-tag",
        "url": "facility_master_anaesthesia_master",
        "auto_crud": true,
        "breadcrumb": "Anaesthesia"
      },
      {
        "name": "menu.diagnostic_master",
        "resource": "facility_master_diagnostic_master",
        "icon": "fa fa-tag",
        "url": "facility_master_diagnostic_master",
        "auto_crud": true,
        "breadcrumb": "Diagnostic"
      },
      {
        "name": "menu.anaesthesia_subtype_master",
        "resource": "facility_master_anaesthesia_subtype_master",
        "icon": "fa fa-tag",
        "url": "facility_master_anaesthesia_subtype_master",
        "auto_crud": true,
        "breadcrumb": "Anaesthesia Sub-Type"
      },
      {
        "name": "menu.reason_master",
        "resource": "facility_master_reason_master",
        "icon": "fa fa-tag",
        "url": "facility_master_reason_master",
        "auto_crud": true,
        "breadcrumb": "Reason"
      },
      {
        "name": "menu.facility_master_stage_master",
        "resource": "facility_master_stage_master",
        "icon": "fa fa-tag",
        "url": "facility_master_stage_master",
        "auto_crud": true,
        "breadcrumb": "Facility Master Stage Master",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.facility_master_body_part",
        "resource": "facility_master_body_part",
        "icon": "fa fa-tag",
        "url": "facility_master_body_part",
        "auto_crud": true,
        "breadcrumb": "Body Part"
      },
      {
        "name": "menu.facility_master_body_specification_mapping",
        "resource": "facility_master_body_specification_mapping",
        "icon": "fa fa-tag",
        "url": "facility_master_body_specification_mapping",
        "auto_crud": true,
        "breadcrumb": "Body Part Specification Mapping"
      },
      {
                name: 'menu.update_tariff',
                resource: 'facility_master_tariff_master',
                icon: 'fa fa-plus-square',
                url: 'facility_master_tariff_master',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            }
    ]
  },
  {
    "name": "menu.billing_master",
    "icon": "fa fa-tag",
    "data": {
      "nav_url": "facility_master_payment_type_m"
    },
    "children": [
      {
        "name": "menu.payer_group",
        "icon": "fa fa-user",
        "resource": "payer_group",
        "url": "payer_group",
        "auto_crud": true,
        "breadcrumb": "Payer Group"
      },
      {
        "name": "menu.payer_subgroup",
        "icon": "fa fa-user",
        "resource": "payer_sub_group",
        "url": "payer_sub_group",
        "auto_crud": true,
        "breadcrumb": "Payer SubGroup"
      },
      {
        "name": "menu.payer_master",
        "icon": "fa fa-user",
        "resource": "payer",
        "url": "payer",
        "auto_crud": true,
        "breadcrumb": "Payer Master"
      },
      {
        "name": "menu.payer_master",
        "icon": "fa fa-user",
        "resource": "payer_master",
        "url": "payer_master",
        "auto_crud": true,
        "breadcrumb": "Payer Master"
      },
      {
        "name": "menu.charity_payer_item_mapping",
        "icon": "fa fa-tag",
        "resource": "charity_payer_item_mapping",
        "url": "charity_payer_item_mapping",
        "auto_crud": true,
        "breadcrumb": "Charity Payer Item Mapping",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.sponsor",
        "icon": "fa fa-user",
        "resource": "sponsor",
        "url": "sponsor",
        "auto_crud": true,
        "breadcrumb": "Sponsor"
      },
      {
        "name": "menu.tariff_dependency",
        "icon": "fa fa-tag",
        "resource": "tariff_dependency",
        "url": "tariff_dependency",
        "auto_crud": true,
        "breadcrumb": "Tariff Dependency"
      },
      {
        "name": "menu.tariff_dependency_priority",
        "icon": "fa fa-tag",
        "resource": "tariff_dependency_priority",
        "url": "tariff_dependency_priority",
        "auto_crud": true,
        "breadcrumb": "Tariff Dependency"
      },
      {
        "name": "menu.tariff_dependency_billing_category",
        "icon": "fa fa-tag",
        "resource": "tariff_dependency_billing_category",
        "url": "tariff_dependency_billing_category",
        "auto_crud": true,
        "breadcrumb": "Tariff Dependency BillingCategory"
      },
      {
        "name": "menu.tariff_billing_category_wise",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_billing_category",
        "url": "tariff_service_item_billing_category",
        "auto_crud": true,
        "breadcrumb": "Tariff Billing Category Wise"
      },
      {
        "name": "menu.tariff_service_wise",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_service_wise",
        "url": "tariff_service_item_service_wise",
        "auto_crud": true,
        "breadcrumb": "Tariff Service Wise"
      },
      {
        "name": "menu.tariff_service_item_priority",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_priority",
        "url": "tariff_service_item_priority",
        "auto_crud": true,
        "breadcrumb": "Tariff Service Wise"
      },
      {
        "name": "menu.surgery_tariff",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_surgery",
        "url": "tariff_service_item_surgery",
        "auto_crud": true,
        "breadcrumb": "Surgery Tariff"
      },
      {
        "name": "menu.doctor_tariff",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_doctor",
        "url": "tariff_service_item_doctor",
        "auto_crud": true,
        "breadcrumb": "Doctor Tariff"
      },
      {
        "name": "menu.doctor_tariff_range",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_doctor_range",
        "url": "tariff_service_item_doctor_range",
        "auto_crud": true,
        "breadcrumb": "Doctor Tariff Range"
      },
      {
        "name": "menu.room_rent_tariff",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_room_rent",
        "url": "tariff_service_item_room_rent",
        "auto_crud": true,
        "breadcrumb": "Room Rent Tariff"
      },
      {
        "name": "menu.tariff_copy",
        "icon": "fa fa-tag",
        "resource": "tariff_copy",
        "url": "tariff_copy",
        "auto_crud": true,
        "breadcrumb": "Tariff Copy"
      },
      {
        "name": "menu.tariff_priority",
        "icon": "fa fa-tag",
        "resource": "tariff_priority",
        "url": "tariff_priority",
        "auto_crud": true,
        "breadcrumb": "Tariff Priority"
      },
      {
        "name": "menu.package_billing_rule",
        "icon": "fa fa-tag",
        "resource": "package_billing_rule",
        "url": "package_billing_rule",
        "auto_crud": true,
        "breadcrumb": "Package Billing Rule"
      },
      {
        name: 'menu.package_schedule_event',
        resource: 'package_schedule_event',
        icon: 'fa fa-superpowers',
        url: 'package_schedule_event',
        auto_crud: true,
        breadcrumb: 'Package Schedule Setup'
      },
      {
        name: 'menu.package_schedule_event_copy',
        resource: 'package_schedule_event_copy',
        icon: 'fa fa-superpowers',
        url: 'package_schedule_event_copy',
        auto_crud: true,
        breadcrumb: 'Package Schedule Setup'
      },
      {
        "name": "menu.surgery_billing_rule",
        "icon": "fa fa-tag",
        "resource": "surgery_billing_rule",
        "url": "surgery_billing_rule",
        "auto_crud": true,
        "breadcrumb": "Surgery Billing Rule"
      },
      {
        "name": "menu.service_charge_master",
        "icon": "fa fa-tag",
        "resource": "service_charge_master",
        "url": "service_charge_master",
        "auto_crud": true,
        "breadcrumb": "Service Charge Master"
      },
      {
        "name": "menu.note_type",
        "icon": "fa fa-tag",
        "resource": "note_type",
        "url": "note_type",
        "auto_crud": true,
        "breadcrumb": "Note Type"
      },
      {
        "name": "menu.discharge_billing_sequence_master",
        "icon": "fa fa-tag",
        "resource": "discharge_billing_sequence_master",
        "url": "discharge_billing_sequence_master",
        "auto_crud": true,
        "breadcrumb": "Discharge Billing Sequence Master"
      },
      {
        "name": "menu.surgery_sequence_master",
        "icon": "fa fa-tag",
        "resource": "surgery_sequence_master",
        "url": "surgery_sequence_master",
        "auto_crud": true,
        "breadcrumb": "Surgery Sequence Master"
      },
      {
        "name": "Authorized Level Matrix",
        "icon": "fa fa-tag",
        "resource": "authorized_level_matrix",
        "url": "authorized_level_matrix",
        "auto_crud": true,
        "breadcrumb": "Authorized Level Matrix"
      },
      {
        "name": "menu.authority_master",
        "icon": "fa fa-tag",
        "resource": "authority_master",
        "url": "authority_master",
        "auto_crud": true,
        "breadcrumb": "Authority Master"
      },
      {
        "name": 'menu.payer_code_copy',
        "resource": 'payer_code_copy',
        "icon": 'fa fa-user',
        "url": 'payer_code_copy',
        "auto_crud": true,
        "breadcrumb": 'Payer Code Copy'
      },
      {
        "name": 'menu.payer_code_master',
        "resource": 'payer_code_master',
        "icon": 'fa fa-user',
        "url": 'payer_code_master',
        "auto_crud": true,
        "breadcrumb": 'Payer Code Master'
      },
      {
        "name": 'menu.payer_code_master_service_item',
        "resource": 'payer_code_master_service_item',
        "icon": 'fa fa-user',
        "url": 'payer_code_master_service_item',
        "auto_crud": true,
        "breadcrumb": 'Payer Code Service Item'
      },
      {
        "name": 'menu.payer_code_master_service_item1',
        "resource": 'payer_code_master_service_item1',
        "icon": 'fa fa-user',
        "url": 'payer_code_master_service_item1',
        "auto_crud": true,
        "breadcrumb": 'Payer Code Service Item1'
      },
      {
        "name": 'menu.payer_code_master_service_type',
        "resource": 'payer_code_master_service_type',
        "icon": 'fa fa-user',
        "url": 'payer_code_master_service_type',
        "auto_crud": true,
        "breadcrumb": 'Payer Code Service Item'
      },
      {
        "name": "menu.ambulance_tariff",
        "icon": "fa fa-tag",
        "resource": "tariff_service_item_ambulance",
        "url": "tariff_service_item_ambulance",
        "auto_crud": true,
        "breadcrumb": "Ambulance Tariff"
      },
      {
        "name": "menu.op_payer_details",
        "icon": "fa fa-tag",
        "resource": "op_payer_details",
        "url": "op_payer_details",
        "auto_crud": true,
        "breadcrumb": "Payer Details",
        "showMenu": false
      },
      {
        "name": "menu.op_amount",
        "icon": "fa fa-tag",
        "resource": "op_amount",
        "url": "op_amount",
        "auto_crud": true,
        "breadcrumb": "Op Amount",
        "showMenu": false
      }
    ]
  },
  {
    name: 'menu.doctor_master',
    icon: 'fa fa-building-o',
    data: {
      nav_url: "practitioner_m"
    },
    children: [

      {
        name: 'menu.practitioner_doctor',
        resource: 'practitioner_facility_details_doctor',
        icon: 'fa fa-superpowers',
        url: 'practitioner_facility_details_doctor',
        auto_crud: true,
        breadcrumb: 'Doctor'
      },
      {
        name: 'menu.practitioner_others',
        resource: 'practitioner_facility_details_other',
        icon: 'fa fa-superpowers',
        url: 'practitioner_facility_details_other',
        auto_crud: true,
        breadcrumb: 'Doctor'
      },
      {
        name: 'menu.practitioner',
        resource: 'practitioner',
        icon: 'fa fa-superpowers',
        url: 'practitioner',
        auto_crud: true,
        check_permission: false,
        breadcrumb: 'Doctor'
      },
       {
        name: 'menu.appointment_bulk_cancellation',
        resource: 'appointment_bulk_cancellation',
        icon: 'fa fa-superpowers',
        url: 'appointment_bulk_cancellation',
        auto_crud: true,
        check_permission: false,
        breadcrumb: 'Doctor'
      },
      {
        name: 'menu.assistant_surgeon_mapping_master',
        resource: 'assistant_surgeon_mapping_master',
        icon: 'fa fa-superpowers',
        url: 'assistant_surgeon_mapping_master',
        auto_crud: true,
        check_permission: false,
        breadcrumb: 'Doctor'
      },
      {
        "name": "menu.speciality_department_mapping_master",
        "icon": "fa fa-tag",
        "resource": "speciality_department_mapping_master",
        "url": "speciality_department_mapping_master",
        "auto_crud": true,
        "breadcrumb": "Speciality Department Mapping Master"
      },
      {
        name: 'menu.practitioner_visit_main',
        resource: 'practitioner_visit_main',
        icon: 'fa fa-superpowers',
        url: 'practitioner_visit_main',
        auto_crud: true,
        breadcrumb: 'Doctor Visit'
      },
      {
        name: 'menu.practitioner_visit',
        resource: 'practitioner_visit',
        icon: 'fa fa-superpowers',
        url: 'practitioner_visit',
        auto_crud: true,
        breadcrumb: 'Doctor Visit',
        showMenu: false
      },
      {
        name: 'menu.doctor_master_onbording_format',
        resource: 'doctor_master_onbording_format',
        icon: 'fa fa-superpowers',
        url: 'doctor_master_onbording_format',
        auto_crud: true,
        breadcrumb: 'Doctor Schedule Setup',
        showMenu: false
      },
      {
        name: 'menu.schedule_event',
        resource: 'schedule_event',
        icon: 'fa fa-superpowers',
        url: 'schedule_event',
        auto_crud: true,
        breadcrumb: 'Doctor Schedule Setup',
        showMenu: false
      },
      {
        name: 'menu.schedule_event',
        resource: 'schedule_event_group',
        icon: 'fa fa-superpowers',
        url: 'schedule_event_group',
        auto_crud: true,
        breadcrumb: 'Doctor Schedule Setup',
        showMenu: false
      },
      {
        name: 'menu.copy_schedule_event',
        resource: 'copy_schedule_event',
        icon: 'fa fa-superpowers',
        url: 'copy_schedule_event',
        auto_crud: true,
        breadcrumb: ' Copy Doctor Schedule'
      },
      {
        name: 'menu.schedule_event_visit',
        resource: 'schedule_event_visit',
        icon: 'fa fa-superpowers',
        url: 'schedule_event_visit',
        auto_crud: true,
        breadcrumb: 'Doctor Schedule Setup'
      },
      {
        "name": "menu.doctor_schedule_event",
        "icon": "fa fa-building-o",
        "resource": "doctor_schedule_event",
        "url": "doctor_schedule_event",
        "auto_crud": true,
        "breadcrumb": "doctor_schedule_event"
      },
      {
        name: 'menu.schedule_event_off',
        resource: 'schedule_event_off_doctor',
        icon: 'fa fa-superpowers',
        url: 'schedule_event_off_doctor',
        auto_crud: true,
        breadcrumb: 'Doctor Off Schedule'
      },

      {
        name: 'menu.off_schedule_format_doctor',
        resource: 'off_schedule_format_doctor',
        icon: 'fa fa-superpowers',
        url: 'off_schedule_format_doctor',
        auto_crud: true,
        breadcrumb: 'Doctor Off Schedule'
      },
      {
        name: 'menu.schedule_event_off',
        resource: 'schedule_event_off',
        icon: 'fa fa-superpowers',
        url: 'schedule_event_off',
        auto_crud: true,
        breadcrumb: 'Doctor Off Schedule'
      },

      {
        name: 'menu.off_schedule_format',
        resource: 'off_schedule_format',
        icon: 'fa fa-superpowers',
        url: 'off_schedule_format',
        auto_crud: true,
        breadcrumb: 'off schedule format'
      },
      {
        name: 'menu.unblock_schedule_report',
        resource: 'unblock_schedule_report',
        icon: 'fa fa-superpowers',
        url: 'unblock_schedule_report',
        auto_crud: true,
        breadcrumb: 'unblock Schedule Report'
      },
      {
        name: 'menu.unblock_schedule_report',
        resource: 'unblock_schedule_report_doctor',
        icon: 'fa fa-superpowers',
        url: 'unblock_schedule_report_doctor',
        auto_crud: true,
        breadcrumb: 'unblock Schedule Report'
      },
      {
        name: 'menu.practitioner_doctor',
        resource: 'practitioner_doctor',
        icon: 'fa fa-superpowers',
        url: 'practitioner_doctor',
        auto_crud: true,
        breadcrumb: 'Doctor',
        showMenu: false
      },
      {
        name: 'menu.practitioner_doctor',
        resource: 'practitioner_others',
        icon: 'fa fa-superpowers',
        url: 'practitioner_others',
        auto_crud: true,
        breadcrumb: 'Doctor',
        showMenu: false
      },
      {
        name: 'Appointment Reminder Master',
        resource: 'appointment_reminder_master',
        icon: 'fa fa-superpowers',
        url: 'appointment_reminder_master',
        auto_crud: true,
        breadcrumb: 'Appointment Reminder Master'
      },
      {
        name: 'Appointment Reminder Master',
        resource: 'appointment_stage_master',
        icon: 'fa fa-superpowers',
        url: 'appointment_stage_master',
        auto_crud: true,
        breadcrumb: 'Appointment Reminder Master'
      }
    ]
  },
  {
    name: 'menu.holiday_master',
    icon: 'fa fa-building-o',
    data: {
      nav_url: "holiday_master"
    },
    children: [
      {
        name: 'menu.holiday_calender',
        resource: 'holiday_calender',
        icon: 'fa fa-superpowers',
        url: 'holiday_calender',
        auto_crud: true,
        breadcrumb: 'Holiday Calender'
      },
      {
        name: 'menu.emergency_timing_master',
        resource: 'emergency_timing_master',
        icon: 'fa fa-superpowers',
        url: 'emergency_timing_master',
        auto_crud: true,
        breadcrumb: 'Emergency Timing Master'
      },
      {
        name: 'menu.emergency_holiday_rule',
        resource: 'emergency_holiday_rule',
        icon: 'fa fa-superpowers',
        url: 'emergency_holiday_rule',
        auto_crud: true,
        breadcrumb: 'Emergency Holiday Rule'
      }
    ]
  },
  {
    name: 'menu.queue_master',
    icon: 'fa fa-building-o',
    data: {
      nav_url: "queue_master_slot_base_queue"
    },
    children: [
      {
        name: 'menu.desk_creation',
        resource: 'desk_creation',
        icon: 'fa fa-superpowers',
        url: 'desk_creation',
        auto_crud: true,
        breadcrumb: 'Desk Creation',
      },
      {
        name: 'menu.screen_master',
        resource: 'screen_master',
        icon: 'fa fa-superpowers',
        url: 'screen_master',
        auto_crud: true,
        breadcrumb: 'Screen Master',
      },
      {
        name: 'menu.holiday_calender',
        resource: 'desk_master_view',
        icon: 'fa fa-superpowers',
        url: 'desk_master_view',
        auto_crud: true,
        breadcrumb: 'Holiday Calender'
      },
      {
        name: 'menu.display_name_master',
        resource: 'display_name_master',
        icon: 'fa fa-superpowers',
        url: 'display_name_master',
        auto_crud: true,
        breadcrumb: 'Display Name Master',
      },
      {
        name: 'menu.type_master',
        resource: 'type_master',
        icon: 'fa fa-superpowers',
        url: 'type_master',
        auto_crud: true,
        breadcrumb: 'Type Master',
      },
      {
        name: 'menu.desk_master',
        resource: 'desk_master',
        icon: 'fa fa-superpowers',
        url: 'desk_master',
        auto_crud: true,
        breadcrumb: 'Desk Master',
      },
      {
        name: 'menu.queue_location',
        resource: 'queue_location',
        icon: 'fa fa-superpowers',
        url: 'queue_location',
        auto_crud: true,
        breadcrumb: 'Queue Location'
      },
       //desk_master
      {
        name: 'menu.queue_master_slot_base_queue',
        resource: 'queue_master_slot_base_queue',
        icon: 'fa fa-superpowers',
        url: 'queue_master_slot_base_queue',
        auto_crud: true,
        breadcrumb: 'Queue Master'
      },
      {
        name: 'menu.queue_master_slot_base_queue_main',
        resource: 'queue_master_slot_base_queue_main',
        icon: 'fa fa-superpowers',
        url: 'queue_master_slot_base_queue_main',
        auto_crud: true,
        check_permission: false,
        breadcrumb: 'Queue Master'
      },
      {
        name: 'menu.immunization_patient',
        resource: 'immunization_patient',
        icon: 'fa fa-superpowers',
        url: 'immunization_patient',
        auto_crud: true,
        breadcrumb: 'immunization patient'
      }
    ]
  },

  {
    "name": "menu.rpd_clinic",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "organization_rpdclinic_m"
    },
    "children": [
      {
        "name": "menu.rpd_clinic",
        "resource": "organization_rpdclinic",
        "url": "organization_rpdclinic",
        "auto_crud": true,
        "breadcrumb": "RPD Clinic"
      },
      {
        "name": "menu.associate_hospital",
        "resource": "associate_hospital_list",
        "url": "associate_hospital_list",
        "auto_crud": true,
        "breadcrumb": "Associate Hospital",
        "showMenu": false
      }
    ]
  },
  {
    "name": "menu.rpd_clinic",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "organization_rpdclinic_m"
    },
    "children": [
      {
        "name": "menu.rpd_clinic",
        "resource": "organization_rpdclinic",
        "url": "organization_rpdclinic",
        "auto_crud": true,
        "breadcrumb": "RPD Clinic"
      },
      {
        "name": "menu.associate_hospital",
        "resource": "associate_hospital_list",
        "url": "associate_hospital_list",
        "auto_crud": true,
        "breadcrumb": "Associate Hospital",
        "showMenu": false
      }
    ]
  },
  {
    "name": "menu.diet_master",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "dietkitchen_m"
    },
    "children": [

      {
        "name": 'menu.facility_master_diet_type',
        "resource": "facility_master_diet_type",
        "url": 'facility_master_diet_type',
        "auto_crud": true
      },
      {
        "name": 'menu.facility_master_meal_time',
        "resource": "facility_master_meal_time",
        "url": 'facility_master_meal_time',
        "auto_crud": true
      },
      {
        "name": 'menu.facility_master_meal_item',
        "resource": "facility_master_meal_item",
        "url": 'facility_master_meal_item',
        "auto_crud": true
      },
      {
        "name": 'menu.diet_definition',
        "resource": "diet_definition",
        "url": 'diet_definition',
        "auto_crud": true
      },
      {
        "name": "menu.therapeutic_restriction",
        "resource": "therapeutic_restriction",
        "view": "therapeutic_restriction",
        "icon": "fa fa-tag",
        "url": "therapeutic_restriction",
        "breadcrumb": "Therapeutic Restriction",
        "auto_crud": true
      }
    ]
  },
  {
    "name": "menu.ambulance",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "ambulance_m"
    },
    "children": [
      {
        "name": "menu.ambulance_details",
        "resource": "ambulance_details",
        "icon": "fa fa-tag",
        "url": "ambulance_details",
        "breadcrumb": "Ambulance Details",
        "auto_crud": true
      },
      {
        "name": "menu.ambulance_base_station",
        "resource": "ambulance_base_station",
        "icon": "fa fa-tag",
        "url": "ambulance_base_station",
        "breadcrumb": "Ambulance Base Station",
        "auto_crud": true
      },
      {
        "name": "menu.ambulance_checklist",
        "resource": "checklist",
        "icon": "fa fa-tag",
        "url": "checklist",
        "breadcrumb": "Ambulance Checklist",
        "auto_crud": true
      },
      {
        "name": "Ambulance Documents",
        "resource": "ambulance_documents",
        "icon": "fa fa-tag",
        "url": "ambulance_documents",
        "breadcrumb": "Ambulance Checklist",
        "auto_crud": false
      },
      {
        "name": "Driver Documents",
        "resource": "driver_documents",
        "icon": "fa fa-tag",
        "url": "driver_documents",
        "breadcrumb": "driver_documents",
        "auto_crud": false
      }

    ]
  },
  {
    "name": "menu.scheme_definition",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "scheme_m"
    },
    "children": [
      {
        "name": "menu.scheme_detail_bill",
        "icon": "fa fa-building-o",
        "resource": "scheme_detail_bill",
        "url": "scheme_detail_bill",
        "auto_crud": true,
        "breadcrumb": "Bill-Wise Scheme"
      },
      {
        "name": "menu.scheme_detail_service_type",
        "icon": "fa fa-building-o",
        "resource": "scheme_detail_service_type",
        "url": "scheme_detail_service_type",
        "auto_crud": true,
        "breadcrumb": "Service Type-Wise Scheme"
      },
      {
        "name": "menu.scheme_detail_custom",
        "icon": "fa fa-building-o",
        "resource": "scheme_detail_custom",
        "url": "scheme_detail_custom",
        "auto_crud": true,
        "breadcrumb": "scheme_detail_custom"
      },
      {
        "name": "menu.scheme_detail_service_item",
        "icon": "fa fa-building-o",
        "resource": "scheme_detail_service_item",
        "url": "scheme_detail_service_item",
        "auto_crud": true,
        "breadcrumb": "Service Item-Wise Scheme"
      }


    ]
  },
  {
    "name": "Create  Dashboard",
    "icon": "fa fa-building-o",
    "resource": "dashboard_master_list",
    "url": "dashboard_master_list",
    "breadcrumb": "Create Dashboard",
    "auto_crud": true
  },
  {
    "name": 'menu.manage_email_groups',
    "resource":"manage_email_groups",
    "icon": 'fa fa-h-square',
    "url": 'manage_email_groups',
    "check_permission":false,
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "Facility Worklist",
    "icon": "fa fa-building-o",
    "resource": "facility_worklist",
    "url": "facility_worklist",
    "breadcrumb": "Facility Worklist",
    "auto_crud": true
  },
  {
    "name": "Facility Worklist Mapping",
    "icon": "fa fa-building-o",
    "resource": "facility_worklist_mapping",
    "url": "facility_worklist_mapping",
    "breadcrumb": "Facility Worklist Mapping",
    "auto_crud": true
  },
  {
    name: 'Citizen Service Facility Mapping',
    resource: 'citizen_service_facility_mapping',
    icon: 'fa fa-plus-square',
    url: 'citizen_service_facility_mapping',
    auto_crud: true,
    breadcrumb: 'Citizen Service Facility Mapping',
    showMenu: true
  },
  {
    "name": "menu.ar_ageing_master",
    "icon": "fa fa-building-o",
    "data": {
      "nav_url": "ar_ageing_master_m"
    },
    "children": [
      {
        "name": "menu.ar_ageing_master",
        "icon": "fa fa-building-o",
        "resource": "ar_ageing_master",
        "url": "ar_ageing_master",
        "auto_crud": true,
        "breadcrumb": "AR Ageing Master"
      },
      {
        "resource": "citizen_service_facility_mapping",
        "url": "citizen_service_facility_mapping",
        "auto_crud": true
      },
      {
        name: 'menu.resource_share',
        resource: 'resource_share',
        url: 'resource_share',
        auto_crud: true,
        breadcrumb: 'resource_share',
        showMenu: false
      },
      {
        name: 'menu.exclude_resource',
        resource: 'exclude_resource',
        url: 'exclude_resource',
        auto_crud: true,
        breadcrumb: 'exclude_resource',
        showMenu: false
      }

    ]
  },
  {
    name: 'Tariff Service Item Department',
    resource: 'tariff_service_item_department',
    icon: 'fa fa-plus-square',
    url: 'tariff_service_item_department',
    auto_crud: true,
    breadcrumb: 'Tariff Service Item Department',
    showMenu: true
  },
  {
    name: 'Data Set Template Master',
    resource: 'dataset_template_master',
    icon: 'fa fa-plus-square',
    url: 'dataset_template_master',
    auto_crud: true,
    breadcrumb: 'Data Set Template Master',
    showMenu: true
  },
  {
    name: 'Data Set Template Master Update',
    resource: 'dataset_template_master_update',
    icon: 'fa fa-plus-square',
    url: 'dataset_template_master_update',
    auto_crud: true,
    breadcrumb: 'Data Set Template Update',
    showMenu: true
  },
  {
    "name": 'menu.facility_master_package_type_mapping',
    "resource": 'facility_master_package_type_mapping',
    "url": 'facility_master_package_type_mapping',
    "auto_crud": true,
    "breadcrumb": 'Package Type Mapping',
    "showMenu": true
  },
  {
    "name": 'menu.facility_master_tariff_country_mapping',
    "resource": 'facility_master_tariff_country_mapping',
    "url": 'facility_master_tariff_country_mapping',
    "auto_crud": true,
    "breadcrumb": 'Country Tariff Mapping',
    "showMenu": true
  },
  {
    "name": 'menu.facility_master_tariff_country_mapping_care_plan',
    "resource": 'facility_master_tariff_country_mapping_care_plan',
    "url": 'facility_master_tariff_country_mapping_care_plan',
    "auto_crud": true,
    "breadcrumb": 'Country Tariff Mapping',
    "showMenu": true
  },
  {
    "name": 'menu.facility_master_admission_type',
    "resource": "facility_master_admission_type",
    "url": 'facility_master_admission_type',
    "auto_crud": true
  },
  {
    "name": 'menu.amp',
    "resource": "account_master_payer",
    "url": 'account_master_payer',
    "auto_crud": true,
    "breadcrumb": 'Account Payer Mapping',
    "showMenu": true
  },
  {
    "name": 'menu.ams',
    "resource": "account_master_scheme",
    "url": 'account_master_scheme',
    "auto_crud": true,
    "breadcrumb": 'Account Scheme Mapping',
    "showMenu": true
  },
  {
    "resource": "patientType_wardType_mapping",
    "url": 'patientType_wardType_mapping',
    "auto_crud": true
  },
  {
    "name": "menu.care_plan_detail",
    "resource": "care_plan_detail",
    "icon": "fa fa-plus-square",
    "url": "care_plan_detail",
    "auto_crud": true,
    "breadcrumb": "pathology",
    "showMenu": false,
    "check_permission": false
  },
  {
    "name": "menu.care_plan_detail_copy",
    "resource": "care_plan_detail_copy",
    "icon": "fa fa-plus-square",
    "url": "care_plan_detail_copy",
    "auto_crud": true,
    "breadcrumb": "pathology",
    "showMenu": false,
    "check_permission": false
  },
  {
    "name": 'menu.view_config_details',
    "resource": "view_config_details",
    "url": 'view_config_details',
    "auto_crud": true,
    "breadcrumb": 'View Config Details',
    "showMenu": true
  },
  {
    "name": 'menu.patient_refer',
    "resource": "patient_refer",
    "url": 'patient_refer',
    "auto_crud": true,
    "breadcrumb": 'View Config Details',
    "showMenu": true
  },
  {
    name: 'menu.item_procedure_mapping',
    resource: 'item_procedure_mapping',
    icon: 'fa fa-user',
    url: 'item_procedure_mapping',
    auto_crud: true,
    breadcrumb: 'Item Procedure Mapping'
  },

]
